/**
 * Stable CSS class names for E2E — Create return / Active step 1.
 */
export const CRAS1 = {
    root: 'create-return-step1',
    radioCol: 'create-return-step1__radio-col',
    radio: 'create-return-step1-input--radio-shipping',

    contentCol: 'create-return-step1__content-col',
    collapsibleWrap: 'create-return-step1__collapsible-wrap',
    headerRow: 'create-return-step1__header-row',
    shippingNoText: 'create-return-step1__shipping-no-text',

    sellerChip: 'create-return-step1__seller-chip',

    errorTooltipWrap: 'create-return-step1__error-tooltip-wrap',
    errorBox: 'create-return-step1__error-box',
    errorIcon: 'create-return-step1__error-icon',
    errorText: 'create-return-step1__error-text',

    notReturnableTooltipWrap: 'create-return-step1__not-returnable-tooltip-wrap',
    notReturnableBox: 'create-return-step1__not-returnable-box',
    notReturnableIcon: 'create-return-step1__not-returnable-icon',
    notReturnableText: 'create-return-step1__not-returnable-text',

    productsWrap: 'create-return-step1__products-wrap',
    productRowWrap: 'create-return-step1__product-row-wrap',
} as const;

export const cras1Cls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

